import classNames from 'clsx';
import React, { useEffect, useRef } from 'react';

import styles from './PriorityImage.scss';

interface PriorityImageProps {
  imageUrl: string;
  fallbackUrl?: string;
  altText: string;
  fetchPriority?: 'auto' | 'low' | 'high';
  className?: string;
}

const PriorityImage: React.FC<PriorityImageProps> = ({
  imageUrl,
  fallbackUrl,
  altText,
  fetchPriority = 'auto',
  className
}) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!fallbackUrl) {
      return;
    }

    const handleImageError = (_: string | Event) => {
      if (imgRef?.current) imgRef.current.src = fallbackUrl;
    };

    const imgElement = imgRef.current;
    if (imgElement) {
      imgElement.src = imageUrl;
      imgElement.onerror = handleImageError;
    }
  }, [imageUrl, fallbackUrl]);

  return (
    <img
      src={imageUrl}
      ref={imgRef}
      // @ts-expect-error not supported in current react version
      fetchpriority={fetchPriority}
      loading="eager"
      alt={altText}
      className={classNames(styles.base, className)}
    />
  );
};

export default PriorityImage;
